import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NavigationService } from 'src/app/core/service/navigation.service';
import {
  cloneData,
  isEmptyObj,
  replaceBracesWithValues,
} from 'src/app/helper/class/utilityHelper';
import {
  button,
  buttonGroup,
  buttonSinge,
  pSeverity,
} from 'src/app/helper/interface/form-interface';
import { tableAction } from 'src/app/helper/interface/response';
import { userPermission } from 'src/app/helper/interface/user';
import { AuthService } from 'src/app/helper/service/auth.service';
import { ModalService } from 'src/app/shared/service/modal.service';

@Component({
  selector: 'm-button',
  template: `<p-button
    pRipple
    *ngIf="show == undefined || show"
    [size]="size"
    [styleClass]="class"
    noDoubleClick
    [severity]="severity"
    (throttledClick)="onClick.emit($event)"
    [loading]="loading"
    [raised]="true"
    [disabled]="disabled"
    [label]="label | translate"
    [icon]="icon"
  ></p-button>`,
  styles: [],
})
export class ButtonComponent implements OnInit {
  @Input() config: button = {};
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;
  @Input() label: any = undefined;
  @Input() class: any = undefined;
  @Input() icon: any = undefined;
  @Input() permission: userPermission | any;
  @Input() severity: pSeverity = 'info';
  @Input() size: 'small' | 'large' | undefined = 'large';
  @Output() onClick: EventEmitter<any> = new EventEmitter();
  @Input() show: boolean | undefined = true;
  constructor(private auth: AuthService) {}
  ngOnInit() {
    const p = this.permission || undefined;
    if (p) {
      this.show = this.auth.checkPermission(p.moduleName, p.actionName);
    }
  }
}

@Component({
  selector: 'm-groupButton',
  template: `<ng-container *ngFor="let a of _btnGroup">
    <m-button
      [show]="a.show"
      [class]="a?.class + ' ml-2'"
      [severity]="a?.severity || 'info'"
      [loading]="a?.loading || false"
      [disabled]="a?.disabled || false"
      [label]="a?.label"
      [icon]="a?.icon"
      [loading]="a?.loading || false"
      [disabled]="a.disabled || false"
      (onClick)="btnClick(a.type)"
    ></m-button>
  </ng-container> `,
  styles: [],
})
export class ButtonGroupComponent implements OnInit {
  constructor(
    private navServe: NavigationService,
    private _bsModalRef: BsModalRef,
    private modalService: ModalService
  ) {}
  @Input() public set btnGroup(e) {
    this._btnGroup = e;
    this.addBackBtn();
  }
  _btnGroup: buttonGroup = [];
  @Input() bkBtnShow: boolean = true;
  @Input() bkBtnUrl: {
    keyName: string;
    subKeyName: string;
    queryparam?: any;
    frg?: string;
  } = {} as any;
  @Output() onClick: EventEmitter<any> = new EventEmitter();
  @Input() onclickPromise:
    | ((args?: tableAction, data?: any) => Promise<any>)
    | any;
  isModal: boolean = false;
  async btnClick(type) {
    this.loadingStatus(type, true);
    let data: any = {};
    if (type == 'BACK' && this.bkBtnShow) {
      const s = this.bkBtnUrl;
      if (this._bsModalRef?.id) {
        this._bsModalRef.hide();
      } else if (s?.keyName) {
        this.navServe.navigatePageSegment(
          s.keyName,
          s.subKeyName,
          s?.queryparam || {},
          s?.frg || ''
        );
      } else {
        this.navServe.back();
      }
    } else {
      const b = this._btnGroup.find((a) => a.type == type);
      if (!isEmptyObj(b?.confirmModal)) {
        const confirmModal = cloneData(b?.confirmModal);
        if (confirmModal.message) {
          confirmModal.message = replaceBracesWithValues(confirmModal.message, {})
        }
        const confirmResult = await this.modalService.openConfirmDialog(confirmModal);
        if (!confirmResult) {
          this.loadingStatus(type, false)
          return
        } else {
          data = confirmResult
        }
      }

      if (b?.url) {
        if (this._bsModalRef?.id) {
          await this._bsModalRef.hide();
          setTimeout(() => {
            this.navByConfig(b?.url, type);
          }, 500);
        } else {
          this.navByConfig(b?.url, type);
        }
      } else {
        this.onclickPromise?.(type)?.then((res) => {
          this.loadingStatus(type, false);
        });
      }
    }
    this.onClick.emit(type);
  }

  navByConfig(url, type) {
    this.navServe.navigatePageSegment(
      url?.keyName,
      url?.subKeyName,
      url?.queryparam
    );
    this.loadingStatus(type, false);
  }

  ngOnInit(): void {
    this.addBackBtn();
  }
  addBackBtn(): any {
    //check already back btn is there
    setTimeout(() => {
      const s = this._btnGroup.find((a) => a.type == 'BACK');
      if (s) {
        return;
      }
      const back_color = this._btnGroup.find((a) => a.severity == 'danger')
        ?.type
        ? 'help'
        : 'danger';
      if (this.bkBtnShow) {
        const backBtn: any[] = !isEmptyObj(this.bkBtnUrl)
          ? [
              {
                label: 'Close/Back',
                icon: 'pi pi-caret-left',
                severity: 'info',
                type: 'BACK',
              },
            ]
          : [
              {
                label: 'Close/Back',
                icon: 'pi pi-caret-left',
                severity: back_color,
                type: 'BACK',
              },
            ];
        this._btnGroup = [...this._btnGroup, ...backBtn];
      }
    }, 300);
  }
  loadingStatus(type: string | 'ALL', status: boolean = false) {
    this._btnGroup.forEach((e: any) => {
      if (e.type == type || e.type == 'ALL') {
        e.loading = status;
      } else {
        e.disabled = status;
      }
    });
  }
}
